import { createContext } from 'react';

import { API_BASE, INDICATOR } from './config';

export const ApiContext = createContext({
  apiBase: API_BASE,
  indicator: INDICATOR,
});
